module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-x-fill-cf934efd.svg";